import React from "react";
import styled from "styled-components";
import ServiceBreakdownList from "components/salesPayment/ServiceBreakdownList";
import { SERVICE_COLOR } from "components/salesPayment/colors";
import type { ServiceBreakdown } from "types/ManagerPayment";

interface Props {
  breakdown: ServiceBreakdown;
}

export const SummaryInfo = ({ breakdown }: Props) => {
  const items = breakdown?.items || [];
  const bar = items
    .filter((it) => it.amount > 0)
    .map((it) => (
      <li
        key={it.code}
        style={{ width: it.percentage + "%", background: SERVICE_COLOR[it.code] }}
      />
    ));
  return (
    <Wrapper>
      <div className="chartInfo">
        <ul>{bar.length ? bar : <li className="empty" />}</ul>
      </div>
      <div className="summaryInfo">
        <ServiceBreakdownList breakdown={breakdown} />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .chartInfo {
    padding: 32px 0 24px;
  }
  .chartInfo ul {
    display: flex;
    margin: 0 -1.5px;
    height: 20px;
    border-radius: 6px;
    overflow: hidden;
  }
  .chartInfo ul li {
    margin: 0 1.5px;
  }
  .chartInfo ul li.empty {
    width: 100%;
    background-color: var(--gray);
    opacity: 0.33;
  }
`;

export default SummaryInfo;
